export class Link {
  DistrictLink_ID: number;
  IconType: string;
  IsDistrictLevel: string;
  IsOneSISTile: string;
  LinkFormatted: string;
  LinkName: string;
  LinkOrder: number;
  LinkToolTip: string;
  LinkUrl: string;
  Link_ID: number;
  Mem_ID: number;
  OpenAsHTTPS: boolean;
  OpenAsNewWindow: boolean;
  TileColor: string;
  TileImageFile: string;
}

export class NewLink {
  Description: string;
  Id: number;
  LinkToolTip: string;
  OpenAsHTTPS: any;
  OpenAsNewWindow: any;
  QuickJumpDescription: string;
  Sequence: number;
  WebAddress: string;
}
